export default {
  estudantes: state => state.estudantes,
  estudante: state => state.estudante,
  paginacao: state => state.paginacao,
  ordenacaoBusca: state => state.ordenacaoBusca,
  formBusca: state => state.formBusca,
  unidades: state => state.unidades,
  modalidades: state => state.modalidades,
  cursos: state => state.cursos,
  versoes: state => state.versoes,
  turmas: state => state.turmas,
  max_ch_unidade: state => state.max_ch_unidade,
  variaveisSimulacao: state => state.variaveisSimulacao,
  variaveisInformacoes: state => state.variaveisInformacoes,
  estudanteSimulacao: state => state.estudanteSimulacao,
  variaveisImportancia: state => state.variaveisImportancia,
  formSimulacao: state => state.formSimulacao,
  modelo: state => state.modelo,
};



// WEBPACK FOOTER //
// ./src/pages/estudantes/store/getters.js